import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/image/cgzy.png';
const _hoisted_1 = {
  src: _imports_0,
  alt: "Create App",
  style: {
    "width": "100%",
    "margin": "0 auto"
  }
};
import { useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'Cgzy',
  setup(__props) {
    const router = useRouter();
    const handleSelect = item => {
      // console.log(item);
      router.push({
        path: item
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("img", _hoisted_1);
    };
  }
});